import React, {useState} from 'react'
import Errors from "./errors";
import Hint from "../hint";
import Required from "./required";
import Icon from "../../ui-kit/icon";
import {_t} from '../../../../js/translation';
import {classNames} from "../../tools/react.dom.helpers";

const InputField = (props) => {
    const [revealed, setRevealed] = useState(false);
    let valueProps = props.controlled ? {value: props.value} : {defaultValue: props.value};
    const isRevealable = props.type === 'password' && props.revealable;
    const inputType = isRevealable && revealed ? 'text' : (props.type || 'text');

    // Opt-in: normalizes the visible value the instant focus leaves the field, instead of only
    // trimming server-side (Symfony's form TrimListener) and leaving the input showing the raw,
    // untrimmed text the user typed until their next full page load — confusing since it looks
    // like the padding was saved verbatim. Mutates the native event's value in place so the
    // existing `(e) => onChange(name, e.target.value)` consumers need no changes.
    const handleBlur = (e) => {
        if (props.trimOnBlur) {
            const trimmed = e.target.value.trim();
            if (trimmed !== e.target.value) {
                e.target.value = trimmed;
                props.onChange && props.onChange(e);
            }
        }
        props.onBlur && props.onBlur(e);
    };

    return (
        <div className={classNames("form-group form-group__input", props.errors && '--error', props.className && props.className)}>
            {props.label &&
                <span className={"form-group__label-wrapper " + (props.hintText ? 'form-group__label--has-hint' : '')}>
                    <label htmlFor={props.name} className={"form-group__label label"}>
                        {props.icon ? <i className={"form-group__label-icon fal " + (props.icon)}/> : ''}
                        {_t(props.label)}
                        {props.markRequired && <Required/>}
                    </label>
                    {props.hintText ? <Hint title={props.hintTitle} text={props.hintText}/> : ''}
                </span>
            }
            <div className="form-group__input-wrapper">
                <div className={classNames("form-group__input-control", isRevealable && "form-group__input-control--revealable", props.prefix && "form-group__input-control--has-prefix")}>
                    {props.prefix &&
                        <span className="form-group__input-prefix">
                            {props.prefix}
                        </span>
                    }
                    <input
                        {...valueProps}
                        onChange={props.onChange}
                        onBlur={handleBlur}
                        onFocus={props.onFocus}
                        type={inputType}
                        name={props.name}
                        onKeyPress={props.onKeyPress}
                        autoFocus={props.autoFocus}
                        autoComplete={props.autoComplete}
                        disabled={props.disabled}
                        required={props.required}
                        id={props.name}
                        step={props.step}
                        min={props.min}
                        max={props.max}
                        inputMode={props.inputMode}
                        pattern={props.pattern}
                        maxLength={props.maxLength}
                        placeholder={_t(props.placeholder || props.label)}
                        className={"form-group__input input form-control " + (props.errors ? 'is-invalid' : '')}
                        readOnly={props.readOnly}
                        onClick={props.onClick}
                    />

                    {isRevealable &&
                        <span
                            role="button"
                            tabIndex={0}
                            className="form-group__reveal-btn"
                            aria-label={_t(revealed ? 'Hide' : 'Show')}
                            onClick={() => setRevealed(v => !v)}
                        >
                            <Icon icon={revealed ? Icon.ICON.INVISIBLE : Icon.ICON.VISIBLE}/>
                        </span>
                    }

                    {props.suffix &&
                        <span className="form-group__input-suffix">
                            {props.suffix}
                        </span>
                    }
                </div>

                {props.errors &&
                    <Errors errors={props.errors} customClass="harmonizely-error-basic form-group__input-error"/>}
            </div>
        </div>
    );
};

export default InputField;